export default [
  {
    ccode: "US",
    code: "1",
    label: "USA",
    value: "+1",
  },
  {
    ccode: "GB",
    code: "44",
    label: "UK",
    value: "+44",
  },
  {
    ccode: "DZ",
    code: "213",
    label: "Algeria",
    value: "+213",
  },
  {
    ccode: "AD",
    code: "376",
    label: "Andorra",
    value: "+376",
  },
  {
    ccode: "AO",
    code: "244",
    label: "Angola",
    value: "+244",
  },
  {
    ccode: "AI",
    code: "1264",
    label: "Anguilla",
    value: "+1264",
  },
  {
    ccode: "AG",
    code: "1268",
    label: "Antigua & Barbuda",
    value: "+1268",
  },
  {
    ccode: "AR",
    code: "54",
    label: "Argentina",
    value: "+54",
  },
  {
    ccode: "AM",
    code: "374",
    label: "Armenia",
    value: "+374",
  },
  {
    ccode: "AW",
    code: "297",
    label: "Aruba",
    value: "+297",
  },
  {
    ccode: "AU",
    code: "61",
    label: "Australia",
    value: "+61",
  },
  {
    ccode: "AT",
    code: "43",
    label: "Austria",
    value: "+43",
  },
  {
    ccode: "AZ",
    code: "994",
    label: "Azerbaijan",
    value: "+994",
  },
  {
    ccode: "BS",
    code: "1242",
    label: "Bahamas",
    value: "+1242",
  },
  {
    ccode: "BH",
    code: "973",
    label: "Bahrain",
    value: "+973",
  },
  {
    ccode: "BD",
    code: "880",
    label: "Bangladesh",
    value: "+880",
  },
  {
    ccode: "BB",
    code: "1246",
    label: "Barbados",
    value: "+1246",
  },
  {
    ccode: "BY",
    code: "375",
    label: "Belarus",
    value: "+375",
  },
  {
    ccode: "BE",
    code: "32",
    label: "Belgium",
    value: "+32",
  },
  {
    ccode: "BZ",
    code: "501",
    label: "Belize",
    value: "+501",
  },
  {
    ccode: "BJ",
    code: "229",
    label: "Benin",
    value: "+229",
  },
  {
    ccode: "BM",
    code: "1441",
    label: "Bermuda",
    value: "+1441",
  },
  {
    ccode: "BT",
    code: "975",
    label: "Bhutan",
    value: "+975",
  },
  {
    ccode: "BO",
    code: "591",
    label: "Bolivia",
    value: "+591",
  },
  {
    ccode: "BA",
    code: "387",
    label: "Bosnia Herzegovina",
    value: "+387",
  },
  {
    ccode: "BW",
    code: "267",
    label: "Botswana",
    value: "+267",
  },
  {
    ccode: "BR",
    code: "55",
    label: "Brazil",
    value: "+55",
  },
  {
    ccode: "BN",
    code: "673",
    label: "Brunei",
    value: "+673",
  },
  {
    ccode: "BG",
    code: "359",
    label: "Bulgaria",
    value: "+359",
  },
  {
    ccode: "BF",
    code: "226",
    label: "Burkina Faso",
    value: "+226",
  },
  {
    ccode: "BI",
    code: "257",
    label: "Burundi",
    value: "+257",
  },
  {
    ccode: "KH",
    code: "855",
    label: "Cambodia",
    value: "+855",
  },
  {
    ccode: "CM",
    code: "237",
    label: "Cameroon",
    value: "+237",
  },
  {
    ccode: "CA",
    code: "1",
    label: "Canada",
    value: "+1",
  },
  {
    ccode: "CV",
    code: "238",
    label: "Cape Verde Islands",
    value: "+238",
  },
  {
    ccode: "KY",
    code: "1345",
    label: "Cayman Islands",
    value: "+1345",
  },
  {
    ccode: "CF",
    code: "236",
    label: "Central African Republic",
    value: "+236",
  },
  {
    ccode: "CL",
    code: "56",
    label: "Chile",
    value: "+56",
  },
  {
    ccode: "CN",
    code: "86",
    label: "China",
    value: "+86",
  },
  {
    ccode: "CO",
    code: "57",
    label: "Colombia",
    value: "+57",
  },
  {
    ccode: "KM",
    code: "269",
    label: "Comoros",
    value: "+269",
  },
  {
    ccode: "CG",
    code: "242",
    label: "Congo",
    value: "+242",
  },
  {
    ccode: "CK",
    code: "682",
    label: "Cook Islands",
    value: "+682",
  },
  {
    ccode: "CR",
    code: "506",
    label: "Costa Rica",
    value: "+506",
  },
  {
    ccode: "HR",
    code: "385",
    label: "Croatia",
    value: "+385",
  },
  {
    ccode: "CU",
    code: "53",
    label: "Cuba",
    value: "+53",
  },
  {
    ccode: "CY",
    code: "90",
    label: "Cyprus - North",
    value: "+90",
  },
  {
    ccode: "CY",
    code: "357",
    label: "Cyprus - South",
    value: "+357",
  },
  {
    ccode: "CZ",
    code: "420",
    label: "Czech Republic",
    value: "+420",
  },
  {
    ccode: "DK",
    code: "45",
    label: "Denmark",
    value: "+45",
  },
  {
    ccode: "DJ",
    code: "253",
    label: "Djibouti",
    value: "+253",
  },
  {
    ccode: "DM",
    code: "1809",
    label: "Dominica",
    value: "+1809",
  },
  {
    ccode: "DO",
    code: "1809",
    label: "Dominican Republic",
    value: "+1809",
  },
  {
    ccode: "EC",
    code: "593",
    label: "Ecuador",
    value: "+593",
  },
  {
    ccode: "EG",
    code: "20",
    label: "Egypt",
    value: "+20",
  },
  {
    ccode: "SV",
    code: "503",
    label: "El Salvador",
    value: "+503",
  },
  {
    ccode: "GQ",
    code: "240",
    label: "Equatorial Guinea",
    value: "+240",
  },
  {
    ccode: "ER",
    code: "291",
    label: "Eritrea",
    value: "+291",
  },
  {
    ccode: "EE",
    code: "372",
    label: "Estonia",
    value: "+372",
  },
  {
    ccode: "ET",
    code: "251",
    label: "Ethiopia",
    value: "+251",
  },
  {
    ccode: "FK",
    code: "500",
    label: "Falkland Islands",
    value: "+500",
  },
  {
    ccode: "FO",
    code: "298",
    label: "Faroe Islands",
    value: "+298",
  },
  {
    ccode: "FJ",
    code: "679",
    label: "Fiji",
    value: "+679",
  },
  {
    ccode: "FI",
    code: "358",
    label: "Finland",
    value: "+358",
  },
  {
    ccode: "FR",
    code: "33",
    label: "France",
    value: "+33",
  },
  {
    ccode: "GF",
    code: "594",
    label: "French Guiana",
    value: "+594",
  },
  {
    ccode: "PF",
    code: "689",
    label: "French Polynesia",
    value: "+689",
  },
  {
    ccode: "GA",
    code: "241",
    label: "Gabon",
    value: "+241",
  },
  {
    ccode: "GM",
    code: "220",
    label: "Gambia",
    value: "+220",
  },
  {
    ccode: "GE",
    code: "7880",
    label: "Georgia",
    value: "+7880",
  },
  {
    ccode: "DE",
    code: "49",
    label: "Germany",
    value: "+49",
  },
  {
    ccode: "GH",
    code: "233",
    label: "Ghana",
    value: "+233",
  },
  {
    ccode: "GI",
    code: "350",
    label: "Gibraltar",
    value: "+350",
  },
  {
    ccode: "GR",
    code: "30",
    label: "Greece",
    value: "+30",
  },
  {
    ccode: "GL",
    code: "299",
    label: "Greenland",
    value: "+299",
  },
  {
    ccode: "GD",
    code: "1473",
    label: "Grenada",
    value: "+1473",
  },
  {
    ccode: "GP",
    code: "590",
    label: "Guadeloupe",
    value: "+590",
  },
  {
    ccode: "GU",
    code: "671",
    label: "Guam",
    value: "+671",
  },
  {
    ccode: "GT",
    code: "502",
    label: "Guatemala",
    value: "+502",
  },
  {
    ccode: "GN",
    code: "224",
    label: "Guinea",
    value: "+224",
  },
  {
    ccode: "GW",
    code: "245",
    label: "Guinea - Bissau",
    value: "+245",
  },
  {
    ccode: "GY",
    code: "592",
    label: "Guyana",
    value: "+592",
  },
  {
    ccode: "HT",
    code: "509",
    label: "Haiti",
    value: "+509",
  },
  {
    ccode: "HN",
    code: "504",
    label: "Honduras",
    value: "+504",
  },
  {
    ccode: "HK",
    code: "852",
    label: "Hong Kong",
    value: "+852",
  },
  {
    ccode: "HU",
    code: "36",
    label: "Hungary",
    value: "+36",
  },
  {
    ccode: "IS",
    code: "354",
    label: "Iceland",
    value: "+354",
  },
  {
    ccode: "IN",
    code: "91",
    label: "India",
    value: "+91",
  },
  {
    ccode: "ID",
    code: "62",
    label: "Indonesia",
    value: "+62",
  },
  {
    ccode: "IQ",
    code: "964",
    label: "Iraq",
    value: "+964",
  },
  {
    ccode: "IR",
    code: "98",
    label: "Iran",
    value: "+98",
  },
  {
    ccode: "IE",
    code: "353",
    label: "Ireland",
    value: "+353",
  },
  {
    ccode: "IL",
    code: "972",
    label: "Israel",
    value: "+972",
  },
  {
    ccode: "IT",
    code: "39",
    label: "Italy",
    value: "+39",
  },
  {
    ccode: "JM",
    code: "1876",
    label: "Jamaica",
    value: "+1876",
  },
  {
    ccode: "JP",
    code: "81",
    label: "Japan",
    value: "+81",
  },
  {
    ccode: "JO",
    code: "962",
    label: "Jordan",
    value: "+962",
  },
  {
    ccode: "KZ",
    code: "7",
    label: "Kazakhstan",
    value: "+7",
  },
  {
    ccode: "KE",
    code: "254",
    label: "Kenya",
    value: "+254",
  },
  {
    ccode: "KI",
    code: "686",
    label: "Kiribati",
    value: "+686",
  },
  {
    ccode: "KP",
    code: "850",
    label: "Korea - North",
    value: "+850",
  },
  {
    ccode: "KR",
    code: "82",
    label: "Korea - South",
    value: "+82",
  },
  {
    ccode: "KW",
    code: "965",
    label: "Kuwait",
    value: "+965",
  },
  {
    ccode: "KG",
    code: "996",
    label: "Kyrgyzstan",
    value: "+996",
  },
  {
    ccode: "LA",
    code: "856",
    label: "Laos",
    value: "+856",
  },
  {
    ccode: "LV",
    code: "371",
    label: "Latvia",
    value: "+371",
  },
  {
    ccode: "LB",
    code: "961",
    label: "Lebanon",
    value: "+961",
  },
  {
    ccode: "LS",
    code: "266",
    label: "Lesotho",
    value: "+266",
  },
  {
    ccode: "LR",
    code: "231",
    label: "Liberia",
    value: "+231",
  },
  {
    ccode: "LY",
    code: "218",
    label: "Libya",
    value: "+218",
  },
  {
    ccode: "LI",
    code: "417",
    label: "Liechtenstein",
    value: "+417",
  },
  {
    ccode: "LT",
    code: "370",
    label: "Lithuania",
    value: "+370",
  },
  {
    ccode: "LU",
    code: "352",
    label: "Luxembourg",
    value: "+352",
  },
  {
    ccode: "MO",
    code: "853",
    label: "Macao",
    value: "+853",
  },
  {
    ccode: "MK",
    code: "389",
    label: "Macedonia",
    value: "+389",
  },
  {
    ccode: "MG",
    code: "261",
    label: "Madagascar",
    value: "+261",
  },
  {
    ccode: "MW",
    code: "265",
    label: "Malawi",
    value: "+265",
  },
  {
    ccode: "MY",
    code: "60",
    label: "Malaysia",
    value: "+60",
  },
  {
    ccode: "MV",
    code: "960",
    label: "Maldives",
    value: "+960",
  },
  {
    ccode: "ML",
    code: "223",
    label: "Mali",
    value: "+223",
  },
  {
    ccode: "MT",
    code: "356",
    label: "Malta",
    value: "+356",
  },
  {
    ccode: "MH",
    code: "692",
    label: "Marshall Islands",
    value: "+692",
  },
  {
    ccode: "MQ",
    code: "596",
    label: "Martinique",
    value: "+596",
  },
  {
    ccode: "MR",
    code: "222",
    label: "Mauritania",
    value: "+222",
  },
  {
    ccode: "YT",
    code: "269",
    label: "Mayotte",
    value: "+269",
  },
  {
    ccode: "MX",
    code: "52",
    label: "Mexico",
    value: "+52",
  },
  {
    ccode: "FM",
    code: "691",
    label: "Micronesia",
    value: "+691",
  },
  {
    ccode: "MD",
    code: "373",
    label: "Moldova",
    value: "+373",
  },
  {
    ccode: "MC",
    code: "377",
    label: "Monaco",
    value: "+377",
  },
  {
    ccode: "MN",
    code: "976",
    label: "Mongolia",
    value: "+976",
  },
  {
    ccode: "MS",
    code: "1664",
    label: "Montserrat",
    value: "+1664",
  },
  {
    ccode: "MA",
    code: "212",
    label: "Morocco",
    value: "+212",
  },
  {
    ccode: "MZ",
    code: "258",
    label: "Mozambique",
    value: "+258",
  },
  {
    ccode: "MN",
    code: "95",
    label: "Myanmar",
    value: "+95",
  },
  {
    ccode: "NA",
    code: "264",
    label: "Namibia",
    value: "+264",
  },
  {
    ccode: "NR",
    code: "674",
    label: "Nauru",
    value: "+674",
  },
  {
    ccode: "NP",
    code: "977",
    label: "Nepal",
    value: "+977",
  },
  {
    ccode: "NL",
    code: "31",
    label: "Netherlands",
    value: "+31",
  },
  {
    ccode: "NC",
    code: "687",
    label: "New Caledonia",
    value: "+687",
  },
  {
    ccode: "NZ",
    code: "64",
    label: "New Zealand",
    value: "+64",
  },
  {
    ccode: "NI",
    code: "505",
    label: "Nicaragua",
    value: "+505",
  },
  {
    ccode: "NE",
    code: "227",
    label: "Niger",
    value: "+227",
  },
  {
    ccode: "NG",
    code: "234",
    label: "Nigeria",
    value: "+234",
  },
  {
    ccode: "NU",
    code: "683",
    label: "Niue",
    value: "+683",
  },
  {
    ccode: "NF",
    code: "672",
    label: "Norfolk Islands",
    value: "+672",
  },
  {
    ccode: "NP",
    code: "670",
    label: "Northern Marianas",
    value: "+670",
  },
  {
    ccode: "NO",
    code: "47",
    label: "Norway",
    value: "+47",
  },
  {
    ccode: "OM",
    code: "968",
    label: "Oman",
    value: "+968",
  },
  {
    ccode: "PK",
    code: "92",
    label: "Pakistan",
    value: "+92",
  },
  {
    ccode: "PW",
    code: "680",
    label: "Palau",
    value: "+680",
  },
  {
    ccode: "PA",
    code: "507",
    label: "Panama",
    value: "+507",
  },
  {
    ccode: "PG",
    code: "675",
    label: "Papua New Guinea",
    value: "+675",
  },
  {
    ccode: "PY",
    code: "595",
    label: "Paraguay",
    value: "+595",
  },
  {
    ccode: "PE",
    code: "51",
    label: "Peru",
    value: "+51",
  },
  {
    ccode: "PH",
    code: "63",
    label: "Philippines",
    value: "+63",
  },
  {
    ccode: "PL",
    code: "48",
    label: "Poland",
    value: "+48",
  },
  {
    ccode: "PT",
    code: "351",
    label: "Portugal",
    value: "+351",
  },
  {
    ccode: "PR",
    code: "1787",
    label: "Puerto Rico",
    value: "+1787",
  },
  {
    ccode: "QA",
    code: "974",
    label: "Qatar",
    value: "+974",
  },
  {
    ccode: "RE",
    code: "262",
    label: "Reunion",
    value: "+262",
  },
  {
    ccode: "RO",
    code: "40",
    label: "Romania",
    value: "+40",
  },
  {
    ccode: "RU",
    code: "7",
    label: "Russia",
    value: "+7",
  },
  {
    ccode: "RW",
    code: "250",
    label: "Rwanda",
    value: "+250",
  },
  {
    ccode: "SM",
    code: "378",
    label: "San Marino",
    value: "+378",
  },
  {
    ccode: "ST",
    code: "239",
    label: "Sao Tome & Principe",
    value: "+239",
  },
  {
    ccode: "SA",
    code: "966",
    label: "Saudi Arabia",
    value: "+966",
  },
  {
    ccode: "SN",
    code: "221",
    label: "Senegal",
    value: "+221",
  },
  {
    ccode: "CS",
    code: "381",
    label: "Serbia",
    value: "+381",
  },
  {
    ccode: "SC",
    code: "248",
    label: "Seychelles",
    value: "+248",
  },
  {
    ccode: "SL",
    code: "232",
    label: "Sierra Leone",
    value: "+232",
  },
  {
    ccode: "SG",
    code: "65",
    label: "Singapore",
    value: "+65",
  },
  {
    ccode: "SK",
    code: "421",
    label: "Slovak Republic",
    value: "+421",
  },
  {
    ccode: "SI",
    code: "386",
    label: "Slovenia",
    value: "+386",
  },
  {
    ccode: "SB",
    code: "677",
    label: "Solomon Islands",
    value: "+677",
  },
  {
    ccode: "SO",
    code: "252",
    label: "Somalia",
    value: "+252",
  },
  {
    ccode: "ZA",
    code: "27",
    label: "South Africa",
    value: "+27",
  },
  {
    ccode: "ES",
    code: "34",
    label: "Spain",
    value: "+34",
  },
  {
    ccode: "LK",
    code: "94",
    label: "Sri Lanka",
    value: "+94",
  },
  {
    ccode: "SH",
    code: "290",
    label: "St. Helena",
    value: "+290",
  },
  {
    ccode: "KN",
    code: "1869",
    label: "St. Kitts",
    value: "+1869",
  },
  {
    ccode: "SC",
    code: "1758",
    label: "St. Lucia",
    value: "+1758",
  },
  {
    ccode: "SR",
    code: "597",
    label: "Surilabel",
    value: "+597",
  },
  {
    ccode: "SD",
    code: "249",
    label: "Sudan",
    value: "+249",
  },
  {
    ccode: "SZ",
    code: "268",
    label: "Swaziland",
    value: "+268",
  },
  {
    ccode: "SE",
    code: "46",
    label: "Sweden",
    value: "+46",
  },
  {
    ccode: "CH",
    code: "41",
    label: "Switzerland",
    value: "+41",
  },
  {
    ccode: "SY",
    code: "963",
    label: "Syria",
    value: "+963",
  },
  {
    ccode: "TW",
    code: "886",
    label: "Taiwan",
    value: "+886",
  },
  {
    ccode: "TJ",
    code: "992",
    label: "Tajikistan",
    value: "+992",
  },
  {
    ccode: "TH",
    code: "66",
    label: "Thailand",
    value: "+66",
  },
  {
    ccode: "TG",
    code: "228",
    label: "Togo",
    value: "+228",
  },
  {
    ccode: "TO",
    code: "676",
    label: "Tonga",
    value: "+676",
  },
  {
    ccode: "TT",
    code: "1868",
    label: "Trinidad & Tobago",
    value: "+1868",
  },
  {
    ccode: "TN",
    code: "216",
    label: "Tunisia",
    value: "+216",
  },
  {
    ccode: "TR",
    code: "90",
    label: "Turkey",
    value: "+90",
  },
  {
    ccode: "TM",
    code: "993",
    label: "Turkmenistan",
    value: "+993",
  },
  {
    ccode: "TC",
    code: "1649",
    label: "Turks & Caicos Islands",
    value: "+1649",
  },
  {
    ccode: "TV",
    code: "688",
    label: "Tuvalu",
    value: "+688",
  },
  {
    ccode: "UG",
    code: "256",
    label: "Uganda",
    value: "+256",
  },
  {
    ccode: "UA",
    code: "380",
    label: "Ukraine",
    value: "+380",
  },
  {
    ccode: "AE",
    code: "971",
    label: "United Arab Emirates",
    value: "+971",
  },
  {
    ccode: "UY",
    code: "598",
    label: "Uruguay",
    value: "+598",
  },
  {
    ccode: "UZ",
    code: "998",
    label: "Uzbekistan",
    value: "+998",
  },
  {
    ccode: "VU",
    code: "678",
    label: "Vanuatu",
    value: "+678",
  },
  {
    ccode: "VA",
    code: "379",
    label: "Vatican City",
    value: "+379",
  },
  {
    ccode: "VE",
    code: "58",
    label: "Venezuela",
    value: "+58",
  },
  {
    ccode: "VN",
    code: "84",
    label: "Vietnam",
    value: "+84",
  },
  {
    ccode: "VG",
    code: "1",
    label: "Virgin Islands - British",
    value: "+1",
  },
  {
    ccode: "VI",
    code: "1",
    label: "Virgin Islands - US",
    value: "+1",
  },
  {
    ccode: "WF",
    code: "681",
    label: "Wallis & Futuna",
    value: "+681",
  },
  {
    ccode: "YE",
    code: "969",
    label: "Yemen",
    value: "North)(+969",
  },
  {
    ccode: "YE",
    code: "967",
    label: "Yemen",
    value: "South)(+967",
  },
  {
    ccode: "ZM",
    code: "260",
    label: "Zambia",
    value: "+260",
  },
  {
    ccode: "ZW",
    code: "263",
    label: "Zimbabwe",
    value: "+263",
  },
];
